<template>

    <div>
        <div class="mcc-page-header">
            <div class="mu-d-flex ">

                <section class="mu-d-flex mu-flex-row mu-w-100">

                    <h1 class="mu-mb-00">Process details</h1>

                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ (copyProcess) ? helpTextCopy.title : helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>


                </section>

            </div>
        </div>
        <div class="mcc-container--fluid card-padding">
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Designs</li>
                    <li>
                        <a class="table-link" @click="redirectToApplicationList()">Application</a>

                    </li>
                    <li>
                        <router-link class="table-link" :to="CONTEXT_PATH + '/design/applications/' + applicationId">{{
                                    applicationName }}</router-link>
                    </li>
                    <li aria-current="page">Create new</li>
                </ol>
            </nav>
            <div class="mcc-card" v-show="fetchCall">
                <div class="mcc-card__body">
                    <form id="formId" novalidate @submit.prevent="saveProcess()">

                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated=""
                                        style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none"
                                            stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>

                            <div class="mcc-card">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Details</h2>
                                </div>

                                <div class="mcc-card__body">
                                    <div
                                        class="mfc-input-wrapper mu-d-block mfc-form-input-container input-gap  mfc-form-input-wrapper--width">
                                        <label for="name" class="mfc-label--required">Name</label>
                                        <input type="text" id="name" maxlength="50" name="name" required=""
                                            placeholder="Name" :pattern="nameRegex" ref="name"
                                            :value="applicationProcess.name" @input="handleNameChange($event)">
                                        <div class="mfc-help-text"> 
                                            <span>Process name can only be changed from modeller once created.</span>
                                        </div>

                                    </div>
                                    <div
                                        class="mfc-textarea-wrapper mfc-form-input-container input-gap  mfc-form-input-wrapper--width">
                                        <label for="description">Description</label>
                                        <textarea id="description" name="description" maxlength="100"
                                            :pattern="descRegex" ref="description" placeholder="Description"
                                            :value="applicationProcess.description"
                                            @input="applicationProcess.description = $event.target.value"
                                            character-count=""></textarea><div class="mfc-invalid-feedback"></div>
                                        <div class="mfc-help-text">
                                            <span class="mfc-help-text" v-if="applicationProcess.description">  You have {{100 - applicationProcess.description.length}} characters remaining</span>
                                            <span class="mfc-help-text" v-else> You have 100 characters remaining</span>
                                        </div>
                                    </div>

                                    <div class="mfc-select-wrapper input-gap  mfc-form-input-wrapper--width"
                                        v-if="copyProcess && applicationProcess.allVariables != null && applicationProcess.allVariables.length > 0">
                                        <label for="mds_select">Process variables</label>
                                        <select id="processVarSelect" ref="processVarSelect" :value="variables" name="selectedVariables" limit="10" block multiple>
                                            <option v-for="item in applicationProcess.allVariables" :value="item"
                                                :key="item">{{ item }}</option>
                                        </select>
                                        <div class="mfc-help-text">
                                            
                                            <span>Maximum 10 process variables can be selected</span>
                                        </div>

                                    </div>
                                    <TagInput class=" mfc-form-input-wrapper--width" :labels="labelsNew" ref="labels"/>
                                    <div class="input-gap">
                                        <IconSelector class="mu-mb-03" v-if="iconFetched" id="processLogoSelect" label="Process logo" :defaultIcon="procIcon" :iconSet="iconSet" @iconUpdate="updateLogo" />
                                    </div>
                                    <div class="mfc-checkbox-wrapper my-2 mfc-form-input-container" v-if="copyProcess">
                                        <input type="checkbox" value="copyXml" class="mfc-switch" id="copyXml"
                                            ref="copyXml" name="copyXml" :checked="applicationProcess.copyXml"
                                            @change="applicationProcess.copyXml = $event.target.checked"
                                            color="primary">
                                        <label for="copyXml">Copy process diagram</label>

                                    </div>
                                    <div class="mu-d-flex mu-justify-content-end">
                                        <div role="group" class="mcc-button-group mcc-button-group--spaced">



                                            <button type="button" class="mcc-button mcc-button--outline"
                                                @click="handleCancelBtn()" id="cancelBtn" title="Cancel">
                                                <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Cancel</span>
                                            </button>
                                            <button class="mcc-button mcc-button--success" title="Save" id="saveBtn"
                                                type="submit" >
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span
                                                    class="mcc-button__label">Save</span>
                                            </button>
                                        </div>

                                    </div>


                                </div>

                            </div>
                        </div>
                    </form>

                </div>

            </div>
        </div>
    </div>

</template>

<script>
import ApplicationProcessAPI from "../../../services/ApplicationProcessAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import IconSelector from "../../customComponents/IconSelector"
import Utils from "@/script_utils";
import TagInput from "../../common/TagInput.vue";
import {
    displayErrorMessage, checkFormAndTextareaValidations
} from '../../../formvalid.js';
export default {
    name: "ApplicationProcessCreate",
    components: {
        IconSelector,
        TagInput
    },
    data() {
        return {
            applicationProcess: {
                description: '',
                allVariables: [],
                processApplication: {
                    id: this.$route.params.appId
                },
                processLogo: "",
                labels: []
            },
            variables: [],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            applicationId: this.$route.params.appId,
            applicationName: "",
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            copyProcess: false,
            labelsNew: [],
            updateCall: true,
            helpText: constantMessages.BREADCRUMB_HELP["application.process.create"],
            helpTextCopy: constantMessages.BREADCRUMB_HELP["application.process.copy"],
            showHelpText: false,
            procIcon: '',
            iconSet: '',
            iconFetched: false,
            fetchCall: false,
            tagsInputInstance: null,
            labelArray: [],
            selectInstanceEntities : null
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        self.loadInitialData();
        
    },
    methods: {
        loadInitialData() {
            let self = this;
            if (this.$route.query.copyProcessId) {
                self.copyProcess = true;
                ApplicationProcessAPI.copyProcess(
                    this.$route.params.appId,
                    this.$route.query.copyProcessId
                ).then(response => {
                    if (response.data != null && response.data.copyProcess == true) {

                        let props = response.data;
                        self.applicationProcess = props.applicationProcess;
                        if (props.applicationProcess.labels != null && props.applicationProcess.labels != "") {
                            let labelsArray = props.applicationProcess.labels.split(",");
                            labelsArray.forEach(element => {
                                this.labelsNew.push(element);
                            });
                            this.labelArray = labelsArray
                        }
                        if (self.applicationProcess.processLogo != null && self.applicationProcess.processLogo.indexOf(':') != -1) {
                            let procLogo = this.applicationProcess.processLogo.split(':');
                            self.procIcon = procLogo[0];
                            self.iconSet = (procLogo.length > 1 && procLogo[1] != '') ? 'fluency-color' : ''
                        }
                        self.applicationName = self.applicationProcess.processApplication.name;
                        self.variables = self.applicationProcess.selectedVariables;

                    }
                }).finally(() => {
                self.fetchCall = true;
                if (self.applicationProcess.allVariables != null && self.applicationProcess.allVariables.length > 0) {
                    setTimeout(() => {
                            self.selectInstanceEntities = new SlimSelect({
                                select: '#processVarSelect',
                                settings: {
                                    closeOnSelect: false,
                                },
                            })
                            self.selectInstanceEntities.setSelected(self.variables);
                    });
                }
                self.iconFetched = true;

                    this.updateTagsDisabledState();
                });

            } else {
                ApplicationProcessAPI.getApplicationDetails(this.$route.params.appId).then(
                    response => {
                        if (response == null || response == "") {
                            self.$router.push(
                                self.CONTEXT_PATH + "/design/applications"
                            );
                            EventBus.$emit('error-notification', {
                                "msg": "Error while fetching application"
                            });
                            return;
                        }
                        this.applicationName = response.name;

                    }
                );
                self.iconFetched = true;
                self.fetchCall = true;
                this.updateTagsDisabledState();
            }

        },
        async updateTagsDisabledState() {
            await this.$nextTick()
            if (this.applicationProcess.deleted != null) {
                $(this.$refs.labels).attr('disabled', 'disabled');
            }
            if (this.$refs.processVarSelect != null) {
                this.$refs.processVarSelect.value = this.variables;
            }
        },
        updateLogo(obj) {
                this.applicationProcess.processLogo = obj.icon + ':' + obj.iconSet;
        },
        saveProcess() {
            let self = this;
            let form = $('#formId')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }    

            self.applicationProcess.labels = this.$refs.labels.value;
            if (self.$refs.processVarSelect != null) {
                self.applicationProcess.selectedVariables = self.selectInstanceEntities.getSelected();
            }
            
            self.updateCall = false;
            ApplicationProcessAPI.saveProcess(
                this.$route.params.appId,
                "new",
                self.applicationProcess,
                self.copyProcess
            )
                .then(response => {
                    self.updateCall = true;
                    if (response.error) {
                        for (let k in response.messages) {
                            if (k == "name") {
                                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                                self.$refs.name.classList.add("ms-is-invalid")
                            } else if (k == "labels") {
                                displayErrorMessage($('#tags'), constantMessages.MESSAGES[response.messages[k]])
                                $('#tags')[0].classList.add('ms-is-invalid')
                                $('.mfc-tags-input')[0].classList.add('ms-is-invalid')
                            } else {
                                EventBus.$emit('error-notification', {
                                    "msg": constantMessages.MESSAGES[response.messages[k]]
                                });
                            }
                        }
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        this.$router.push(
                            this.CONTEXT_PATH +
                            "/design/applications/" +
                            this.$route.params.appId +
                            "/appprocesses/" +
                            response.data.id
                        );
                    }
                })
                .finally(() => { });
        },



        handleNameChange(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            this.applicationProcess.name = event.target.value;
        },

        getApplicationDetails() {
            ApplicationProcessAPI.getApplicationDetails(
                this.$route.params.appId
            ).then(response => {
                if (response != null) {
                    this.applicationName = response.name;
                }
            });
        },
        redirectToApplicationList() {
            localStorage.setItem("application", "application");

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications'
            );
        },
        handleCancelBtn() {
            let self = this;
            if (!self.copyProcess) {
                self.$router.push(
                    self.CONTEXT_PATH + '/design/applications/' + self.$route.params.appId
                );
                return;
            } else {
                self.$router.push(
                    self.CONTEXT_PATH +
                    "/design/applications/" +
                    self.$route.params.appId +
                    "/appprocesses/" +
                    self.$route.query.copyProcessId
                );
            }
        }
    }
};
</script>
